import React, { useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { useLocation, useHistory } from 'react-router-dom'
import { authenticationService, Help, Input } from '@enkla-gui'
import { icons } from '@config'


export default function Login() {
  const { register, handleSubmit } = useForm()
  const [error, setError] = useState(null)
  const [loading, setLoading] = useState(false)
  const [verifiedMessage, setVerifiedMessage] = useState(null)
  const location = useLocation()
  const history = useHistory()

  let { from } = location.state || { from: { pathname: '/dashboard' } }

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    if (params.get('verified')) {
      setVerifiedMessage('Din e-postadress har verifierats! Logga in för att fortsätta.')
      history.replace(location.pathname)
    } else if (params.get('already_verified')) {
      setVerifiedMessage('Din e-postadress är redan verifierad. Logga in för att fortsätta.')
      history.replace(location.pathname)
    }
  }, [history, location.pathname, location.search])

  if (authenticationService.currentTokenValue !== null) history.push('/dashboard')

  const onSubmit = data => {
    setLoading(true)
    authenticationService
      .login(data.email, data.password)
      .then(res => {
        if (res.mfa_required) {
          const challenge = { mfa_token: res.mfa_token, from }
          try {
            sessionStorage.setItem('mfa_challenge', JSON.stringify(challenge))
          } catch {
            // ignore
          }
          history.push({
            pathname: '/login/mfa',
            mfa_token: res.mfa_token,
            from
          })
          return
        }
        history.push(from)
      })
      .catch(result => {
        if (!result) setError('Något fick fel, försök igen')
        try {
          const [, res] = result
          setError(res)
        } catch {
          setError(true)
        }
      })
      .finally(_ => {
        setLoading(false)
      })
  }
  return (
    <div className='full-height login-page'>
      <div className='login-card'>
        <div className='login-card-inner'>
          <div className='login-info'>
            <div className='login-info-content'>
              <span className='login-welcome'>Välkommen tillbaka</span>
              <img src='images/enkla-fastigheter-black.png' className='login-brand-logo' alt='Enkla Fastigheter' />
              <p className='login-info-subtitle'>Logga in för att hantera dina fastigheter</p>
              <div className='login-accent-line' />
              <p className='login-info-trust'>Betrodd av fastighetsägare över hela Sverige.</p>
            </div>
          </div>
          <div className='login-form-section'>
            <form onSubmit={handleSubmit(onSubmit)}>
              {error &&
                <Help header={false} type='warning' icon={icons.warning}>
                  <span>{error.message}</span>
                </Help>
              }
              {verifiedMessage && (
                <Help header={false} type='success' icon={icons.success}>
                  <span>{verifiedMessage}</span>
                </Help>
              )}
              {history.location.message && (
                <Help header={false} type='success' icon={icons.success}>
                  <span>{history.location.message}</span>
                </Help>
              )}
              <Input
                controls={{ register }}
                name='email'
                label='E-post'
                type='text'
                placeholder='din@epost.se'
              />
              <Input
                controls={{ register }}
                name='password'
                label='Lösenord'
                type='password'
                placeholder='••••••••'
              />
              <button disabled={loading} type='submit' className='btn login-btn'>
                {loading ? (
                  <><i className='fas fa-spinner fa-spin' /> Loggar in...</>
                ) : (
                  'Logga in'
                )}
              </button>
            </form>
            <div className='login-card-links'>
              <p className='login-register-link'>
                Har du inget konto? <a href='#/register'>Registrera dig</a>
              </p>
              <p className='login-forgot-link'>
                <a href='#/forgot'>Jag har glömt mitt lösenord</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
